"use client";

import { ProductCard } from "./ProductCard";
import { products } from "./products";
import { ChevronLeft, ChevronRight, TrendingUp } from "lucide-react";
import Link from "next/link";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export const BestSellersSlider = () => {
    const slides = Math.ceil(products.length / 9);
    const grouped = Array.from({ length: slides }, (_, i) =>
        products.slice(i * 9, i * 9 + 9)
    );

    return (
        <div className="relative ">
            {/* Bottom Curve */}
            <div className='absolute  top-0 inset-x-0 flex justify-center items-end z-50 overflow-hidden'>
                <svg className='w-80 mx-auto transform -translate-y-[50px] rotate-180 z-50' xmlns="http://www.w3.org/2000/svg" width="450" height="100" viewBox="0 0 450 100">
                    <path
                        d="M0,55 C50,55 50,20 100,20 H350 C400,20 400,55 450,55"
                        fill="#0A0512"
                        stroke="#18141D"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </svg>
            </div>
            <section className="relative overflow-hidden bg-background/40 backdrop-blur-sm rounded-3xl border border-border/50 p-5 z-40">



                {/* Background Effects */}
                <div className="absolute inset-0 overflow-hidden opacity-10 z-10">
                    <div className="absolute top-0 -right-20 w-[300px] h-[300px] bg-primary rounded-full blur-[80px]" />
                    <div className="absolute bottom-0 -left-20 w-[250px] h-[250px] bg-primary rounded-full blur-[60px]" />
                </div>

                {/* Header */}
                <div className="relative flex justify-between items-center md:mb-6 mb-3 mt-3 md:mt-0 z-20">
                    <div className="flex items-center gap-2 bg-secondary/30 backdrop-blur-sm px-3 py-1.5 rounded-lg">
                        <TrendingUp size={18} className="text-primary" />
                        <h2 className="md:text-xl text-xs font-bold text-foreground">
                            <span className="text-primary">پرفروش‌ترین </span>
                            <span>محصولات</span>
                        </h2>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="flex items-center gap-2">
                            <button className="swiper-button-prev-custom1 !static bg-secondary/20 hover:bg-secondary/30 text-secondary-foreground rounded-lg w-9 h-9 flex items-center justify-center transition-all hover:scale-105 backdrop-blur-sm">
                                <ChevronRight className="w-4 h-4" />
                            </button>
                            <button className="swiper-button-next-custom1 !static bg-secondary/20 hover:bg-secondary/30 text-secondary-foreground rounded-lg w-9 h-9 flex items-center justify-center transition-all hover:scale-105 backdrop-blur-sm">
                                <ChevronLeft className="w-4 h-4" />
                            </button>
                        </div>
                        <Link
                            href="/products"
                            className="group flex items-center gap-2 bg-primary/20 hover:bg-primary/30 text-primary px-4 py-2 rounded-lg transition-all hover:scale-105 backdrop-blur-sm"
                        >
                            <span className="md:text-sm font-medium text-xs">مشاهده همه</span>
                            <ChevronLeft className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                        </Link>
                    </div>
                </div>

                {/* Swiper */}
                <div className="relative z-20">
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        navigation={{
                            nextEl: '.swiper-button-next-custom1',
                            prevEl: '.swiper-button-prev-custom1',
                        }}
                        loop={true}
                        grabCursor={true}
                        autoplay={{
                            delay: 5000,
                            pauseOnMouseEnter: true
                        }}
                        spaceBetween={24}
                        className="!pb-8 !px-2"
                    >
                        {grouped.map((group, index) => (
                            <SwiperSlide key={index}>
                                <div className="grid md:grid-cols-3 grid-cols-1 gap-8">
                                    {group.map((product) => (
                                        <ProductCard key={product.id} product={product} />
                                    ))}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
        </div>
    );
};
